export default __webpack_public_path__ + "static/media/auraBAL.f294b2e5.png";